export default __webpack_public_path__ + "static/media/stationery.1a644919.png";